import { useLastUnloadedGroups } from "api/wms/hooks";
import styles from "../../Dashboard.module.css";
import { LastUnloadedGroup } from "api/wms/models";
import { comfortableListUiSchema } from "components/miloDesignSystem/molecules/table/uiSchemas";
import { Table } from "components/miloDesignSystem/molecules/table";
import { useSearch } from "../../shared/useSearch";
import { useLastUnloadedOrdersColumns } from "./useLastUnloadedOrdersColumns";
import { Typography } from "components/miloDesignSystem/atoms/typography";

export const LastUnloadedOrders = () => {
  const search = useSearch();
  const { data: lastUnloaded, error, isPreviousData, isLoading } = useLastUnloadedGroups(search);
  const columns = useLastUnloadedOrdersColumns();

  return (
    <div className={styles.card}>
      <div>
        <div className="d-flex align-items-center justify-content-between gap-1 px-3 py-3">
          <Typography className={styles.sectionTitle} fontSize="16" fontWeight="700">
            Ostatnio przyjęte paczki
          </Typography>
        </div>
        <div className="d-flex flex-1 overflow-hidden justify-content-between">
          <Table<LastUnloadedGroup>
            rows={lastUnloaded}
            columns={columns}
            isLoading={isLoading || isPreviousData}
            error={error}
            uiSchema={comfortableListUiSchema}
          />
        </div>
      </div>
    </div>
  );
};
